module.exports = __webpack_public_path__ + "img/pantalla-9-8.3d3bd882.png";